export default "__VITE_PUBLIC_ASSET__c9f7b334__"